import React, { useEffect } from "react";
import { splitSectionName } from "../projectsScheduleHelpers";
import "./FixPlanErrorModal.css";

const FixPlanErrorModal = ({
  open,
  sectionName,
  message,
  title = "Нельзя зафиксировать план",
  onClose,
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  const { code, title: sectionTitle } = splitSectionName(sectionName);

  return (
    <>
      <div className="fix-plan-error-backdrop" onClick={onClose} />
      <div
        className="fix-plan-error-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="fix-plan-error-title"
      >
        <h2 id="fix-plan-error-title" className="fix-plan-error-modal__title">
          {title}
        </h2>
        <div className="fix-plan-error-modal__section">
          {code && <div className="fix-plan-error-modal__code">{code}</div>}
          {(sectionTitle || (!code && sectionName)) && (
            <div className="fix-plan-error-modal__name">
              {sectionTitle || sectionName}
            </div>
          )}
        </div>
        <div className="fix-plan-error-modal__alert">
          <span className="fix-plan-error-modal__icon" aria-hidden>
            ⚠
          </span>
          <p>{message || "Не удалось выполнить операцию с планом раздела."}</p>
        </div>
        <button
          type="button"
          className="fix-plan-error-modal__btn"
          onClick={onClose}
        >
          Понятно
        </button>
      </div>
    </>
  );
};

export default FixPlanErrorModal;
